import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { remove as removeNotificationAction } from 'rebook/apps/users/actions/NotificationActions';

import styles from './style.scss';


class NotificationsPopup extends React.Component {
  closeNotification(event, notificationId) {
    const newTop = event.target.getBoundingClientRect().top + event.target.getBoundingClientRect().height + 30;
    event.target.style.top = `-${newTop}px`;
    setTimeout(function() {
      this.props.removeNotification(notificationId);
    }.bind(this), 500);
  }

  render() {
    const { notifications } = this.props;
    return (
      <div className={styles.container}>
        {notifications.map((notification) => (
          <div className={styles.text}
            key={notification.id}
            onClick={(event) => this.closeNotification(event, notification.id)}>
            {notification.text}
          </div>
        ))}
      </div>
    );
  }
}

NotificationsPopup.propTypes = {
  notifications: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
  })),
};

function mapDispatchToProps(dispatch) {
  return {
    removeNotification: (notificationId) => dispatch(removeNotificationAction(notificationId)),
  };
}

export default connect(null, mapDispatchToProps)(NotificationsPopup);
